import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent {
}
